if (!customElements.get('search-filter')) {
  class SearchFilter extends HTMLElement {

    _usedValuesCache = new Map();           // key -> { makesArr, modelsArr, ts }
_usedValuesCacheOrder = [];             // LRU order of keys
_usedValuesInflight = new Map();        // key -> { controller, promise }
CACHE_TTL_MS = 30_000;                  // 30s “good enough” window
CACHE_MAX_ENTRIES = 40;                 // cap to prevent growth


_makeCacheKey(params) {
  const allow = [];
  params.forEach((v, k) => {
    if (k === 'page' || k === 'view') return; // pagination & view are internal
    // normalize spaces and case (don’t lower keys Shopify cares about)
    allow.push([k, v.trim().replace(/\s+/g, ' ')]);
  });
  // sort by key then value for stable ordering
  allow.sort((a,b) => a[0] === b[0] ? a[1].localeCompare(b[1]) : a[0].localeCompare(b[0]));
  return JSON.stringify(allow);
}


_getFromCache(key) {
  const hit = this._usedValuesCache.get(key);
  if (!hit) return null;
  if (Date.now() - hit.ts > this.CACHE_TTL_MS) {
    // expired
    this._usedValuesCache.delete(key);
    this._usedValuesCacheOrder = this._usedValuesCacheOrder.filter(k => k !== key);
    return null;
    }
  // refresh LRU
  this._usedValuesCacheOrder = this._usedValuesCacheOrder.filter(k => k !== key);
  this._usedValuesCacheOrder.unshift(key);
  // reconstruct Maps from arrays (deep, immutable)
  const makesMap  = new Map(hit.makesArr.map(([k, arr]) => [k, new Set(arr)]));
  const modelsMap = new Map(hit.modelsArr.map(([k, arr]) => [k, new Set(arr)]));
  return { makesMap, modelsMap };
}

_setInCache(key, makesMap, modelsMap) {
  // deep-freezeable, JSON-safe shape
  const makesArr  = [...makesMap.entries()].map(([k, set]) => [k, [...set]]);
  const modelsArr = [...modelsMap.entries()].map(([k, set]) => [k, [...set]]);
  this._usedValuesCache.set(key, { makesArr, modelsArr, ts: Date.now() });

  // LRU maintain
  this._usedValuesCacheOrder = this._usedValuesCacheOrder.filter(k => k !== key);
  this._usedValuesCacheOrder.unshift(key);
  while (this._usedValuesCacheOrder.length > this.CACHE_MAX_ENTRIES) {
    const evict = this._usedValuesCacheOrder.pop();
    this._usedValuesCache.delete(evict);
  }
}

_abortInflight(key) {
  const inflight = this._usedValuesInflight.get(key);
  if (inflight) inflight.controller.abort();
  this._usedValuesInflight.delete(key);
}


    constructor() { super(); }
    connectedCallback() { this.init(); }

    // Paste your full canonical map here (used only for pairing, not for display)
    
    /*
    makeModelMap = {
      "fiat": ["124","126","127","500","500C","500L","500X","Albea","Barchetta","Brava","Bravo","Coupe","Croma","Doblo","Ducato","Fiorino","Freemont","Fullback","Idea","Ka","Linea","Marea","Marengo","Multipla","Palio","Panda","Punto","Qubo","Scudo","Sedici","Seicento","Stilo","Strada","Talento","Tipo","Ulysse","Various"],
      "agco": ["various", "7650"],
      "bmw": ["1 Series","2 Series","3 Series","4 Series","5 Series","6 Series","7 Series","8 Series","X1","X2","X3","X4","X5","X6","X7","Z3","Z4","i3","i4","i8","iX","1 series","2 series","3 series","4 series","5 series","6 series","7 series","8 series","x1","x2","x3","x4","x5","x6","x7","z3","z4","i3","i4","i8","ix"],
      "audi": ["A1","A2","A3","A4","A5","A6","A7","A8","Q2","Q3","Q4","Q5","Q7","Q8","TT","R8","e-tron","a1","a2","a3","a4","a5","a6","a7","a8","q2","q3","q4","q5","q7","q8","tt","r8","e-tron"],
      "Opel": ["Adam","Agila","Ampera","Antara","Astra","Cascada","Combo","Corsa","Crossland","Grandland","Insignia","Karl","Meriva","Mokka","Signum","Tigra","Vectra","Vivaro","Zafira","adam","agila","ampera","antara","astra","cascada","combo","corsa","crossland","grandland","insignia","karl","meriva","mokka","signum","tigra","vectra","vivaro","zafira"],
      "volkswagen": ["Arteon","Beetle","Bora","Caddy","CC","EOS","Fox","Golf","ID.3","ID.4","ID.5","Jetta","Lupo","Passat","Phaeton","Polo","Scirocco","Sharan","T-Cross","T-Roc","Tiguan","Touareg","Touran","Up!","arteon","beetle","bora","caddy","cc","eos","fox","golf","id.3","id.4","id.5","jetta","lupo","passat","phaeton","polo","scirocco","sharan","t-cross","t-roc","tiguan","touareg","touran","up!"],
      "ford": ["B-MAX","C-MAX","EcoSport","Edge","Escape","Escort","Fiesta","Focus","Fusion","Galaxy","Kuga","Mondeo","Mustang","Puma","Ranger","S-Max","Transit","b-max","c-max","ecosport","edge","escape","escort","fiesta","focus","fusion","galaxy","kuga","mondeo","mustang","puma","ranger","s-max","transit"],
      "toyota": ["Auris","Avensis","Aygo","Camry","C-HR","Corolla","GT86","Highlander","Hilux","Land Cruiser","Mirai","Prius","Proace","RAV4","Supra","Verso","Yaris","auris","avensis","aygo","camry","c-hr","corolla","gt86","highlander","hilux","land cruiser","mirai","prius","proace","rav4","supra","verso","yaris"],
      "nissan": ["350Z","370Z","Almera","Ariya","Cube","GT-R","Juke","Leaf","Micra","Murano","Navara","Note","Pathfinder","Patrol","Primera","Pulsar","Qashqai","Terrano","X-Trail","350z","370z","almera","ariya","cube","gt-r","juke","leaf","micra","murano","navara","note","pathfinder","patrol","primera","pulsar","qashqai","terrano","x-trail"],
      "mercedes-Benz": ["A-Class","B-Class","C-Class","CLA","CLK","CLS","E-Class","G-Class","GLA","GLB","GLC","GLE","GLK","GLS","M-Class","R-Class","S-Class","SL","SLC","SLK","Sprinter","V-Class","Vito","a-class","b-class","c-class","cla","clk","cls","e-class","g-class","gla","glb","glc","gle","glk","gls","m-class","r-class","s-class","sl","slc","slk","sprinter","v-class","vito"],
      "peugeot": ["106","107","108","2008","205","206","207","208","3008","301","306","307","308","405","406","407","5008","508","607","806","807","Partner","Rifter"],
      "renault": ["Captur","Clio","Espace","Fluence","Grand Scenic","Kadjar","Kangoo","Koleos","Laguna","Megane","Modus","Scenic","Talisman","Twingo","Twizy","Zoe"],
      "hyundai": ["Accent","Bayon","Coupe","Elantra","Getz","i10","i20","i30","i40","IONIQ","Kona","Matrix","Nexo","Santa Fe","Sonata","Terracan","Tucson","Veloster","Venue"],
      "kia": ["Carens","Ceed","Cerato","EV6","Magentis","Niro","Optima","Picanto","ProCeed","Rio","Sedona","Sorento","Soul","Sportage","Stinger","Venga"],
      "seat": ["Alhambra","Altea","Arosa","Ateca","Cordoba","Exeo","Ibiza","Leon","Mii","Tarraco","Toledo"],
      "skoda": ["Citigo","Enyaq","Fabia","Kamiq","Karoq","Kodiaq","Octavia","Rapid","Roomster","Scala","Superb","Yeti"],
      "mini": ["Clubman","Convertible","Cooper","Countryman","Coupe","One","Paceman","Roadster"],
      "land rover": ["Defender","Discovery","Discovery Sport","Freelander","Range Rover","Range Rover Evoque","Range Rover Sport","Range Rover Velar"],
      "mazda": ["2","3","5","6","CX-3","CX-30","CX-5","CX-60","CX-9","MX-5","RX-8"],
      "honda": ["Accord","Civic","CR-V","CR-Z","FR-V","HR-V","Insight","Integra","Jazz","Legend","Prelude","S2000"],
      "suzuki": ["Alto","Baleno","Celerio","Ignis","Jimny","Liana","Splash","Swift","SX4","Vitara","Wagon R"],
      "volvo": ["C30","C70","S40","S60","S80","S90","V40","V50","V60","V70","V90","XC40","XC60","XC70","XC90"],
      "citroen": ["2CV","AMI","AX","Berlingo","BX","C1","C2","C3","C3 Aircross","C3 Picasso","C4","C4 Aircross","C4 Cactus","C4 Picasso","C4 SpaceTourer","C5","C5 Aircross","C6","C8","CX","DS","DS3","DS4","DS5","E-MEHARI","Grand C4 Picasso","Grand C4 SpaceTourer","GS","Nemo","Saxo","SM","SpaceTourer","Visa","Xantia","XM","Xsara","Xsara Picasso","ZX"],
      "chevrolet": ["Aveo","Blazer","Camaro","Caprice","Captiva","Cavalier","Colorado","Corvette","Cruze","Epica","Equinox","Evanda","Express","HHR","Impala","Kalos","Lacetti","Malibu","Matiz","Nubira","Orlando","Silverado","Spark","Suburban","Tacuma","Tahoe","Tracker","Trailblazer","Trax","Volt"]
    };

    */

    
  makeModelMap = {
  "agco": ["7650","various"],
  "alfa romeo": ["145","146","147","156","159","166","GT","Mito"],
  "ashok leyland": ["Various"],
  "audi": ["A1","A2","A3","A4","A5","A6","A7","A8","Q2","Q3","Q4","Q5","Q7","Q8","R8","TT","Various","a1","a2","a3","a4","a5","a6","a7","a8","e-tron","q2","q3","q4","q5","q7","q8","tt","r8"],
  "bmw": ["1 Series","1 series","2 Series","2 series","3 Series","3 series","4 Series","4 series","5 Series","5 series","6 Series","6 series","7 Series","7 series","8 Series","8 series","Various","X1","X2","X3","X4","X5","X6","X7","Z3","Z4","i3","i4","i8","iX","x1","x2","x3","x4","x5","x6","x7","z3","z4","ix"],
  "case": ["Various"],
  "caterpillar": ["3054E","3056"],
  "chevrolet": ["Aveo","Blazer","Camaro","Caprice","Captiva","Cavalier","Colorado","Corvette","Cruze","Epica","Equinox","Evanda","Express","HHR","Impala","Kalos","Lacetti","Malibu","Matiz","Nubira","Orlando","Silverado","Spark","Suburban","Tacuma","Tahoe","Tracker","Trailblazer","Trax","Volt","malibu"],
  "citroen": ["2CV","AMI","AX","Berlingo","BX","C-Elysee","C1","C2","C3","C3 Aircross","C3 Picasso","C4","C4 Aircross","C4 Cactus","C4 Picasso","C4 SpaceTourer","C5","C5 Aircross","C6","C8","CX","DS","DS3","DS4","DS5","DS7","Dispatch","E-MEHARI","Evasion","Grand C4 Picasso","Grand C4 SpaceTourer","GS","Jumper","Jumpy","Nemo","Relay","Saxo","SM","SpaceTourer","Various","Visa","Xantia","XM","Xsara","Xsara Picasso","ZX"],
  "cupra": ["Formentor"],
  "dacia": ["Dokker","Duster","Jogger","Lodgy","Logan","Sandero","Solenza","Spring"],
  "daf": ["CF","LF","XF"],
  "deutz": ["Various"],
  "dodge": ["Ram"],
  "dongfeng": ["Various"],
  "doosan": ["DL06S"],
  "faw": ["Various"],
  "fendt": ["5220E","5255L","5275C","6275L","6335C","8370P","8400P","9390 R","9470X","9480 R","Various"],
  "fiat": ["124","126","127","500","500C","500L","500X","Albea","Barchetta","Brava","Bravo","Coupe","Croma","Doblo","Ducato","Fiorino","Freemont","Fullback","Idea","Ka","Linea","Marea","Marengo","Multipla","Palio","Panda","Punto","Qubo","Scudo","Sedici","Seicento","Stilo","Strada","Talento","Tipo","Ulysse","Various"],
  "ford": ["B-MAX","C-MAX","EcoSport","Edge","Escape","Escort","F Series","Fiesta","Figo","Focus","Focus C-Max","Fusion","Galaxy","Grand C-Max","Kuga","Mondeo","Mustang","Puma","Ranger","S-Max","Tourneo","Tourneo Connect","Tourneo Courier","Transit","Transit Connect","Transit Tourneo","Various","b-max","c-max","ecosport","edge","escape","escort","fiesta","focus","fusion","galaxy","kuga","mondeo","mustang","puma","ranger","s-max","transit"],
  "fuso": ["Canter"],
  "hino": ["300 Series","500 Series","700 Series","Truck"],
  "hitachi": ["Excavator"],
  "honda": ["Accord","CR-V","CR-Z","Civic","FR-V","HR-V","Insight","Integra","Jazz","Legend","Prelude","S2000","Various"],
  "hyundai": ["Accent","Avante","Bayon","Click","Coupe","Elantra","Getz","Grandeur","H1 / Starex","I10","I20","I30","I40","IONIQ","IX20","IX35","Kona","Matrix","Nexo","Palisade","Santa Fe","Sonata","Staria","Terracan","Trajet","Truck/Bus","Tucson","Veloster","Venue","Verna"],
  "hyundai construction equipment": ["H Engine","L Engine"],
  "infiniti": ["Q50"],
  "isuzu": ["D-Max","F Series","N Series","Rodeo","Various"],
  "iveco": ["CityClass","Daily","EuroCargo","Massif","Scudato","Various"],
  "jaguar": ["E-Pace","E-Type","F-Pace","F-Type","I-Pace","S-Type","X-Type","XE","XF","XJ","XJ6","XJ8","XJR","XJS","XK","XKR"],
  "jcb": ["Agri Loader","Compact Loader","JS Series","Loader","Loader Digger","Mast Loader","Roller","Shovel","Skid Steer Loader","Telescopic Handler","Tracked Digger","Wheeled Loader"],
  "jeep": ["Compass","Patriot"],
  "john deere": ["6020","6030","6930","Tractor","Various"],
  "kia": ["Bongo","Carens","Carnival","Ceed","Cerato","EV6","Magentis","Niro","Optima","Picanto","Pregio","ProCeed","Rio","Sedona","Sorento","Soul","Sportage","Stinger","Stonic","Venga","Xceed"],
  "komatsu": ["BR380JG-1E0","Crawler","D39EX-22","D39PX-22","D65-15","D65-16","Dozer","Excavator","GD555-5","GD655-3","GD655-5","GD675-3","GD675-5","HB205-1","HB205LC-1","HB215LC-1","ISDE6","PC200-8","PC220-8","PC300-8","PC340-7","PC350-8","WA439-6","Wheel Loader"],
  "kubota": ["Industrial","Various"],
  "lancia": ["Kappa","Lybra","Musa","Ypsilon"],
  "land rover": ["Defender","Discovery","Discovery Sport","Freelander","Range Rover","Range Rover Evoque","Range Rover Sport","Range Rover Velar"],
  "landini": ["Legend","Various"],
  "lexus": ["IS200","IS220"],
  "man": ["Bus","Lions City","Lions Coach","Lions Regio","TGA","TGE","TGL","TGS","TGX","Various"],
  "massey ferguson": ["Activa 7244","Activa S 7345/MCS","Activa S 7347/MCS","Beta 7360/PL","Beta 7370/PL","Centora 7280/AL","Centora 7282/AL","Delta 9280/AL","7600 Series","7700 Series","8600 Series","9500 Series","9695 Fortina","Various"],
  "mazda": ["2","3","5","6","BT-50","CX-3","CX-30","CX-5","CX-60","CX-7","CX-9","MPV","MX-5","RX-8"],
  "mccormick": ["MC115","MC120"],
  "mercedes": ["A Class","B Class","C Class","CLA Class","CLC","CLC Class","CLK","CLK Class","CLS","CLS Class","Citan","E Class","G Class","GLA","GLA Class","GLB","GLC","GLE","GLK","GLK Class","GLS","M Class","R Class","S Class","SL","SLC","SLK","Sprinter","T Class","V Class","Various","Viano","Vito"],
  "mercedes Benz": ["A-Class","B-Class","C-Class","CLA","CLK","CLS","E-Class","G-Class","GLA","GLB","GLC","GLE","GLK","GLS","M-Class","R-Class","S-Class","SL","SLC","SLK","Sprinter","V-Class","Vito","a-class","b-class","c-class","cla","clk","cls","e-class","g-class","gla","glb","glc","gle","glk","gls","m-class","r-class","s-class","sl","slc","slk","sprinter","v-class","vito"],
  "mercedes benz trucks": ["Actros","Antos","Arocs","Atego","Econic","Unimog"],
  "mhi": ["Various"],
  "mini": ["Clubman","Convertible","Cooper","Cooper Clubman","Cooper Clubvan","Cooper Countryman","Cooper Paceman","Countryman","Coupe","One","Paceman","Roadster","Various"],
  "mitsubishi": ["ASX","Canter","Evolution","Grandis","L200","Lancer","Outlander","Pajero","Pajero Sport","Various"],
  "nefaz": ["5000"],
  "neoplan": ["trendliner"],
  "new holland": ["T7060","TS110A","TS125A","TS135A","Various"],
  "nissan": ["350Z","350z","370Z","370z","Almera","Ariya","Cabstar","Cube","GT-R","Interstar","Juke","Kubistar","Leaf","Micra","Murano","NV200","NV400","Navara","Note","Pathfinder","Patrol","Primastar","Primera","Pulsar","Qashqai","Terrano","Tiida","X-Trail","almera","ariya","cube","gt-r","juke","leaf","micra","murano","navara","note","pathfinder","patrol","primera","pulsar","qashqai","terrano","x-trail"],
  "Opel": ["Adam","Agila","Ampera","Antara","Astra","Cascada","Combo","Corsa","Crossland","Grandland","Insignia","Karl","Meriva","Mokka","Movano","Omega","Signum","Tigra","Vectra","Vivaro","Zafira","adam","agila","ampera","antara","astra","cascada","combo","corsa","crossland","grandland","insignia","karl","meriva","mokka","signum","tigra","vectra","vivaro","zafira"],
  "paz": ["3000"],
  "perkins": ["Industrial","Various"],
  "peugeot": ["1007","106","107","108","2008","205","206","207","208","3008","301","306","307","308","4008","405","406","407","5008","508","607","806","807","Bipper","Boxer","Expert","Partner","RCZ","Rifter","Traveller","Various"],
  "porsche": ["Cayenne","Macan","Panamera","Various"],
  "renault": ["Avantime","C","Captur","Clio","Espace","Fluence","Grand Scenic","K","Kadjar","Kangoo","Koleos","Laguna","Master","Megane","Modus","Scenic","Symbol","T","Talisman","Thalia","Trafic","Twingo","Twizy","Vel Satis","Zoe"],
  "renault trucks": ["C","K","Kerax","Mascott","Midlum","Premium","T"],
  "saab": ["9-3","9-5"],
  "samsung": ["SM3"],
  "scania": ["G Series","P Series","R Series","S Series","Touring"],
  "seat": ["Alhambra","Altea","Arona","Arosa","Ateca","Cordoba","Exeo","Ibiza","Leon","Mii","Tarraco","Toledo","Various"],
  "skoda": ["Citigo","Enyaq","Fabia","Kamiq","Karoq","Kodiaq","Octavia","Rapid","Roomster","Scala","Superb","Various","Yeti"],
  "ssangyong": ["Actyon","Korando","Kyron","Rexton","Rodius","Turismo"],
  "subaru": ["Forester","Impreza","Legacy","Outback","XV"],
  "suzuki": ["Alto","Baleno","Celerio","Grand Vitara","Ignis","Jimny","Liana","SX4","Splash","Swift","Vitara","Wagon R","WagonR"],
  "tata": ["Indigo","Marina","Safari","Xenon"],
  "temsa": ["Avenue Diesel","Diamond","Safari"],
  "terberg": ["Various"],
  "toyota": ["4Runner","Auris","Avensis","Avensis Verso","Aygo","C-HR","Camry","Corolla","Corolla Verso","Dyna","Fortuner","GT86","Hiace","Highlander","Hilux","Land Cruiser","Mirai","Previa","Prius","Proace","RAV4","Supra","Verso","Yaris","auris","avensis","aygo","camry","c-hr","corolla","gt86","highlander","hilux","land cruiser","mirai","prius","proace","rav4","supra","verso","yaris"],
  "ud trucks": ["Various"],
  "valtra": ["S Series","Various"],
  "vauxhall": ["Agila","Astra","Cascada","Combo","Corsa","Insignia","Meriva","Mokka","Movano","Omega","Signum","Tigra","Vectra","Vivaro","Zafira"],
  "volkswagen": ["Amarok","Arteon","Beetle","Bora","CC","Caddy","California","Caravelle","Crafter","EOS","Fox","Golf","ID.3","ID.4","ID.5","Jetta","Lupo","Multivan","Passat","Phaeton","Polo","Scirocco","Sharan","T-CROSS","T-ROC","Tiguan","Touareg","Touran","Transporter","Up!","Various","arteon","beetle","bora","caddy","cc","eos","fox","golf","id.3","id.4","id.5","jetta","lupo","passat","phaeton","polo","scirocco","sharan","t-cross","t-roc","tiguan","touareg","touran","up!"],
  "volvo": ["C30","C70","FH","FM","FMX","S40","S60","S80","S90","V40","V50","V60","V70","V90","Various","XC40","XC60","XC70","XC90"],
  "volvo industrial": [],
  "volvo trucks": ["FE","FH","FM","FMX"],
  "weichai power": ["Various"],
  "yamz": ["Various"],
  "yanmar": ["Various"],
  "yuchai": ["Various","Xiaobawang"]
};



    // config: whether to list every distinct casing in dropdowns
    SHOW_ALL_ORIGINAL_CASINGS = false;

    _activeController = null;   // AbortController for the current fetch
_reqSeq = 0;                // monotonically increasing request id
_lastAppliedSeq = 0;        // last request id that successfully updated state

    // runtime state: norm -> Set(original labels)
    usedMakesMap  = new Map();
    usedModelsMap = new Map();

    // selection
    selectedMake  = null;
    selectedModel = null;

    async init() {
      this.els = {
        details: this.querySelectorAll('details'),
        submit:  this.querySelector('.filter-value'),
        spinner: this.querySelector('.loading__spinner')
      };

      // base target
     const dataUrl = this.getAttribute('data-filter-url');
this.baseHref = (dataUrl && dataUrl.replace(/\?$/, '')) || this.dataset.filterUrl || '/collections/all';
this.els.submit?.setAttribute('data-previous-href', this.baseHref);


      this.wireDetailsUX();

      this.toggleLoading(true);
      await this.loadUsedValues();            // fetch JSON view (with preview id)
      this.renderMakeList();                  // fill Make (preserve exact labels)
      this.clearModelList();                  // Model waits for Make
      this.bindItemEvents();
      this.refreshSubmitHref();
      this.toggleLoading(false);
    }

    // ---------- UX helpers ----------
    wireDetailsUX() {
      this.els.details.forEach(d => {
        const s = d.querySelector('summary');
        if (!s) return;
        s.tabIndex = 0;
        s.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); d.open = !d.open; }
        });
        d.addEventListener('focusout', () => setTimeout(() => {
          if (!d.contains(document.activeElement)) d.removeAttribute('open');
        }, 0));
      });
      document.addEventListener('click', e => {
        if (![...this.els.details].some(d => d.contains(e.target))) {
          this.els.details.forEach(d => d.removeAttribute('open'));
        }
      });
    }

    toggleLoading(on) {
      // also ensure spinner doesn’t block clicks when hidden
      if (!this.els.spinner) return;
      if (on) {
        this.els.spinner.classList.remove('hidden');
        this.els.spinner.style.pointerEvents = 'none';
      } else {
        this.els.spinner.classList.add('hidden');
        this.els.spinner.style.pointerEvents = 'none';
      }
    }

    // ---------- Fetch used makes/models (preserve originals) ----------
  async loadUsedValues(extraParams) {
  const handle  = (this.dataset.collection || 'all').trim();
  const themeId = window?.Shopify?.theme?.id;

  // Build base params (no page/view yet)
  const baseParams = extraParams instanceof URLSearchParams
    ? new URLSearchParams(extraParams)
    : new URLSearchParams();
  if (themeId) baseParams.set('preview_theme_id', themeId);
  if (this.IN_STOCK_ONLY) baseParams.set(this.AVAIL_PARAM, '1');

  const cacheKey = this._makeCacheKey(baseParams);

  // 1) Try cache
  const cached = this._getFromCache(cacheKey);
  if (cached) {
    this.usedMakesMap  = cached.makesMap;
    this.usedModelsMap = cached.modelsMap;
    return;
  }

  // 2) Coalesce / single-flight for identical key
  if (this._usedValuesInflight.has(cacheKey)) {
    // await the same promise; when it sets cache, our next get will hit
    await this._usedValuesInflight.get(cacheKey).promise;
    const cached2 = this._getFromCache(cacheKey);
    if (cached2) {
      this.usedMakesMap  = cached2.makesMap;
      this.usedModelsMap = cached2.modelsMap;
    }
    return;
  }

  // 3) Start a new fetch (abort previous *different* key fetches if you want)
  const controller = new AbortController();
  const fetchPromise = (async () => {
    // temp collectors so we only write cache when fully complete
    const makes = new Map();
    const models = new Map();

    let page = 1;
    while (true) {
      const loopParams = new URLSearchParams(baseParams);
      loopParams.set('view', 'used-make-models');
      loopParams.set('page', String(page));

      const url = `/collections/${handle}?${loopParams.toString()}`;
      let data;
      try {
        const res = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
        if (!res.ok) {
          if (res.status === 404) break; // treat as empty under race
          throw new Error(`HTTP ${res.status}`);
        }
        const text = await res.text();
        if (text.trim().startsWith('<')) break; // safety: HTML not JSON
        data = JSON.parse(text);
      } catch (e) {
        if (e.name === 'AbortError') return; // coalesced/aborted → silent
        // network or parse error: do not cache; just stop
        return;
      }

      (data?.makes || []).forEach(mk => {
        const k = this.norm(mk);
        if (!makes.has(k)) makes.set(k, new Set());
        makes.get(k).add(mk);
      });
      (data?.models || []).forEach(md => {
        const k = this.norm(md);
        if (!models.has(k)) models.set(k, new Set());
        models.get(k).add(md);
      });

      if (!data?.has_next) break;
      page++;
      if (page > 50) break;
    }

    // Only apply + cache if we fetched at least one page successfully
    this.usedMakesMap  = makes;
    this.usedModelsMap = models;
    // ✅ cache the complete result (deep-cloned, immutable in cache)
    this._setInCache(cacheKey, makes, models);
  })();

  this._usedValuesInflight.set(cacheKey, { controller, promise: fetchPromise });
  try {
    await fetchPromise;
  } finally {
    // clean inflight entry (if not replaced)
    if (this._usedValuesInflight.get(cacheKey)?.promise === fetchPromise) {
      this._usedValuesInflight.delete(cacheKey);
    }
  }
}


    // ---------- Renderers ----------
    renderMakeList() {
      const detail = this.findDetailByLabel('Make');
      const ul = detail?.querySelector('.filter-select');
      if (!ul) return;

      ul.querySelectorAll('.filter-select__item:not(.holder)').forEach(el => el.remove());

      // intersect canonical makes with used makes. For each normalized key in intersection,
      // either show all originals (flag=true) or the first original only.
      const makesToShow = [];

      Object.keys(this.makeModelMap).forEach(rawKey => {
        const normKey   = this.norm(rawKey);
        const originals = this.usedMakesMap.get(normKey);
        if (!originals || !originals.size) return;

        if (this.SHOW_ALL_ORIGINAL_CASINGS) {
          originals.forEach(o => makesToShow.push(o));
        } else {
          makesToShow.push(originals.values().next().value); // representative original
        }
      });

      makesToShow
        .sort((a,b)=>a.localeCompare(b))
        .forEach(label => {
          const filterId = `filter.p.m.custom.make=${label}`; // not pre-encoded
          ul.append(this.createItem(filterId, label, 'Make'));
        });
    }

    clearModelList() {
      const detail = this.findDetailByLabel('Model');
      const ul = detail?.querySelector('.filter-select');
      if (!ul) return;
      ul.querySelectorAll('.filter-select__item:not(.holder)').forEach(el => el.remove());
    }

    renderModelListForMake(makeLabel) {
      const detail = this.findDetailByLabel('Model');
      const ul = detail?.querySelector('.filter-select');
      if (!ul) return;

      this.clearModelList();

      // constrain by canonical pairs
      const canonKey = this.findCanonicalMakeKey(makeLabel);
      const modelsFromMap = (canonKey && Array.isArray(this.makeModelMap[canonKey])) ? this.makeModelMap[canonKey] : [];

      // intersect with used models (preserve originals)
      const modelsToShow = [];
      const seen = new Set(); // to dedupe when SHOW_ALL_ORIGINAL_CASINGS=false

      modelsFromMap.forEach(modelFromMap => {
        const normM = this.norm(modelFromMap);
        const originals = this.usedModelsMap.get(normM);
        if (!originals || !originals.size) return;

        if (this.SHOW_ALL_ORIGINAL_CASINGS) {
          originals.forEach(o => modelsToShow.push(o));
        } else {
          const rep = originals.values().next().value;
          if (!seen.has(rep)) { seen.add(rep); modelsToShow.push(rep); }
        }
      });

      modelsToShow
        .sort((a,b)=>a.localeCompare(b))
        .forEach(label => {
          const filterId = `filter.p.m.custom.model=${label}`; // not pre-encoded
          ul.append(this.createItem(filterId, label, 'Model'));
        });
    }

    // ---------- Interaction ----------
    bindItemEvents() {
      this.querySelectorAll('.filter-select__item:not(.holder)').forEach(item => {
        item.addEventListener('click', () => this.onPick(item));
        item.tabIndex = 0;
        item.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.onPick(item); }
        });
      });
    }

    async onPick(item) {
  const details = item.closest('details');
  const span = details?.querySelector('summary span');
  if (span) span.textContent = item.textContent;

  details?.querySelectorAll('.filter-select__item:not(.holder)').forEach(i => i.classList.remove('active'));
  item.classList.add('active');
  details?.removeAttribute('open');

  const field = (item.getAttribute('data-title') || '').toLowerCase();
  const label = item.textContent.trim();

  if (field === 'make') {
  this.selectedMake  = label;
  this.selectedModel = null;
  this.setSummaryText('Model', 'Model');

  this.debouncedRefetchAndRebuild(120);
  return;
}

  if (field === 'model') {
    this.selectedModel = label;
    this.refreshSubmitHref();
    return;
  }

// ---- Any other filter (e.g., Product type, Vendor, Tag, etc.) picked ----
this.debouncedRefetchAndRebuild(120);}


    // ---------- URL builder ----------
    refreshSubmitHref() {
      const base = this.baseHref || '/collections/all';
      const btn  = this.els?.submit;
      if (!btn) return;

      const params = new URLSearchParams();

      // add OTHER active filters (not make/model) from DOM
      this.querySelectorAll('.filter-select__item.active:not(.holder)').forEach(it => {
        const title = (it.getAttribute('data-title') || '').toLowerCase();
        if (title === 'make' || title === 'model') return;

        const pair = it.getAttribute('data-filter') || '';
        const eq   = pair.indexOf('=');
        if (eq === -1) return;
        const k = pair.slice(0, eq);
        const v = pair.slice(eq + 1);
        const vDecoded = decodeURIComponent(v.replace(/\+/g, ' ')); // avoid %2520
        params.append(k, vDecoded);
      });

      if (this.selectedMake)  params.set('filter.p.m.custom.make',  this.selectedMake);
      if (this.selectedModel) params.set('filter.p.m.custom.model', this.selectedModel);

      const query = params.toString();
      const href  = query ? `${base}?${query}` : base;

      btn.setAttribute('href', href);
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('disabled', 'is-disabled', 'opacity-50', 'pointer-events-none');
    }

    // ---------- Utilities ----------
    findDetailByLabel(txt) {
      return [...(this.els.details || [])].find(d => {
        const s = d.querySelector('summary span');
        return s && s.textContent.trim().toLowerCase() === txt.toLowerCase();
      });
    }
    setSummaryText(label, text) {
      const d = this.findDetailByLabel(label);
      const s = d?.querySelector('summary span');
      if (s) s.textContent = text;
    }
    createItem(filterId, label, title) {
      const li = document.createElement('li');
      li.className = 'filter-select__item';
      li.setAttribute('role', 'button');
      li.setAttribute('data-filter', filterId);  // stored raw; encoded at submit
      li.setAttribute('data-title', title);
      li.textContent = label;                    // exact text, no casing change
      return li;
    }

    // normalize for matching only (never for display)
    norm(s) { return (s || '').toString().toLowerCase().replace(/[\s-]+/g,'').trim(); }
    findCanonicalMakeKey(makeLabel) {
      const target = this.norm(makeLabel);
      for (const k of Object.keys(this.makeModelMap)) {
        if (this.norm(k) === target) return k;
      }
      return null;
    }

    getActiveNonMakeModelParams() {
  const params = new URLSearchParams();
  this.querySelectorAll('.filter-select__item.active:not(.holder)').forEach(it => {
    const title = (it.getAttribute('data-title') || '').toLowerCase();
    if (title === 'make' || title === 'model') return;
    const pair = it.getAttribute('data-filter') || '';
    const eq   = pair.indexOf('=');
    if (eq === -1) return;
    const k = pair.slice(0, eq);
    const v = pair.slice(eq + 1);
    const vDecoded = decodeURIComponent(v.replace(/\+/g, ' ')); // avoid %2520
    params.append(k, vDecoded);
  });
  return params;
}

/** Re-fetch used values for current active filters and rebuild Make/Model UI. */
async refetchAndRebuildModels() {
  // Build params from ALL active non-make/model filters (includes Product type if selected)
  const params = this.getActiveNonMakeModelParams();

  // If a make is selected, include it so the fetch is constrained by both
  if (this.selectedMake) {
    params.set('filter.p.m.custom.make', this.selectedMake);
  }

  this.toggleLoading(true);
  try {
    await this.loadUsedValues(params);

    // Re-render Make list based on the filtered product set
    this.renderMakeList();
    if (this.selectedMake) {
      // Keep Make summary sticky
      this.setSummaryText('Make', this.selectedMake);

      // Rebuild Models under the selected make
      this.renderModelListForMake(this.selectedMake);

      // If a model was previously selected, only keep it if still valid
      if (this.selectedModel) {
        const canonKey = this.findCanonicalMakeKey(this.selectedMake);
        const allowed = new Set((this.makeModelMap[canonKey] || []).map(m => this.norm(m)));
        const stillUsed = this.usedModelsMap.has(this.norm(this.selectedModel));
        const stillAllowed = allowed.has(this.norm(this.selectedModel));
        if (!(stillUsed && stillAllowed)) {
          this.selectedModel = null;
          this.setSummaryText('Model', 'Model');
        } else {
          this.setSummaryText('Model', this.selectedModel);
        }
      }
    } else {
      // No make chosen → keep Models empty until a make is picked
      this.setSummaryText('Model', 'Model');
      this.clearModelList();
    }

    // Bind events for newly injected items
    this.bindItemEvents();
  } finally {
    this.refreshSubmitHref(); // keeps URL in sync (product_type + make + others)
    this.toggleLoading(false);
  }
}

_refetchTimer = null;

debouncedRefetchAndRebuild(delay = 100) {
  clearTimeout(this._refetchTimer);
  this._refetchTimer = setTimeout(() => this.refetchAndRebuildModels(), delay);
}

  }

  customElements.define('search-filter', SearchFilter);
}